module.exports = __webpack_public_path__ + "static/img/team_honor_si.b904caa4.png";